/**
 * What an integration does. Mirrors IntegrationCategory in the NestJS API
 * (src/entities/integration-type.entity.ts); the source of truth is the
 * `integration_types` table.
 */
export enum IntegrationCategory {
  ORDERS = 'ORDERS',
  RETURNS = 'RETURNS',
  SHIPPING = 'SHIPPING',
}

/** A row of the integration_types catalog (GET /integration-types). */
export interface IntegrationType {
  code: string;
  name: string;
  category: IntegrationCategory;
  /** Asset path relative to the app root, e.g. assets/media/stores/loop.png */
  logoUrl?: string | null;
  isEnabled: boolean;
  sortOrder: number;
}
